<style scoped lang="less">
  @import url('/static/document/img-print.css');
  .img-doc-print {
    display: flex;
    height: 100%;
    justify-content: center;
    background-color: rgba(245, 247, 249, 1);
  }
  .left, .right {
    flex: 1;
    max-width: 300px;
  }
  .doc-content {
    padding: 1cm;
    box-sizing: border-box;
    height: 100%;
    overflow: auto;
  }
  .choose-list {
    display: flex;
    flex-wrap: wrap;
  }
  .choose-img {
    width: 230px;
    height: 170px;
    box-sizing: border-box;
    padding: 10px;
    cursor: pointer;
    position: relative;
    img {
      transition: all .3s;
      border-radius: 5px;
      border: 1px solid #EEE;
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
    &:hover {
      img {
        border-color: rgb(8, 143, 206);
      }
    }
  }
  .img-doc-print {
    .doc-content {
      .page {
        padding: 2cm 1.2cm;
        transition: all .3s;
        cursor: pointer;
        border: 1px solid rgba(202, 204, 210, 1);
        &.active {
          border-color: rgb(8, 143, 206);
        }
        & + .page {
          margin-top: 25px;
        }
      }
      .imgs {
        .img {
          cursor: pointer;
          img {
            transition: all .3s;
          }
          &:after {
            transition: all .3s;
            content: '';
            position: absolute;
            right: 0;
            top: 0;
            left: 0;
            bottom: 0;
            pointer-events: none;
            border: 1px solid transparent;
          }
          &.active {
            &:after {
              border-color: rgb(8, 143, 206);
            }
          }
        }
      }
    }
  }
  .plane {
    .block {
      margin-right: 10px;
      box-sizing: border-box;
      background-color: #FFF;
      border: 1px solid transparent;
      border-radius: 8px;
      margin-top: 20px;
      padding: 10px;
      transition: all .3s;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          display: flex;
          align-items: center;
          i {
            margin-right: 10px;
          }
        }
        .action-icon {
          cursor: pointer; color: red; font-size: 16px; font-weight: 800;
        }
      }
      .content {
        margin-top: 5px;
        padding-top: 5px;
        border-top: 1px solid #EEE;
      }
      &.tap {
        cursor: pointer;
        &:hover {
          background-color: rgba(8, 143, 206, .05);
          border-color: rgba(8, 143, 206, .1);
        }
      }
    }
  }
  .img-action-icon {
    cursor: pointer;
    font-size: 20px;
    transition: all .3s;
    &:hover {
      color: rgb(8, 143, 206);
    }
  }
</style>

<style lang="less">
  .img-doc-print {
    .block-icon-actions {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      // justify-content: space-between;
      & > * + * {
        margin-left: 5px;
      }
      .fm-poptip-wrap {
        pointer-events: none;
      }
    }
  }
</style>

<template>
  <div style="height: 100%;position: relative;">
    <div class="img-doc-print">
      <div class="left">
        <slot name="left"></slot>
      </div>
      <div class="doc-content" ref="content">
        <div v-for="(page, i) in pages" :key="i" class="page" :class="{
          [page.direction]: true,
          active: cursor.page === i
        }" @click.stop="togglePage(i)" :data-page-index="i">
          <div class="imgs">
            <div :data-page-img-index="i + '-' + l" v-for="(img, l) in page.imgs" :key="l + '-' + img.src" :class="{
                active: cursor.page === i && cursor.index === l
              }" class="img" :style="{
                [page.direction === 'row' ? 'align-items' : 'justify-content']: img.align,
              }">
              <img :src="img.src" @click.stop="toggleImg(i, l)"/>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="plane">
          <div class="block">
            <div class="title">
              <div class="name">
                <i class="iconfont icon-pages"></i>
                <span style="font-size: 16px; font-weight: 800;">图片打印预览编辑器</span>
              </div>
              <i @click="quit" class="iconfont icon-qidong action-icon"></i>
            </div>
          </div>
          <div class="block" v-show="status.page">
            <div class="title">
              <div class="name">
                <i class="iconfont icon-break-page"></i>
                <span style="font-size: 16px;">页面设置</span>
              </div>
              <i @click="status.page = false" class="iconfont icon-close action-icon" style="font-size: 12px;font-weight: 400;color: #657180;"></i>
            </div>
            <div class="content">
              <div class="block-icon-actions">
                <template v-for="menu in pageMenus">
                  <span style="color: rgb(190,190,190);" :key="menu.key + 'span'"  v-if="menu.split">|</span>
                  <fm-poptip :key="menu.key + 'poptip'"  arrow trigger="hover">
                    <div>
                      <i @click="pageAction(menu)" class="img-action-icon" :class="{[menu.icon]: true}"></i>
                      <span v-if="menu.label">{{menu.label}}</span>
                    </div>
                    <div slot="content" style="white-space: nowrap;padding: 5px;">{{menu.desc}}</div>
                  </fm-poptip>
                </template>
              </div>
            </div>
          </div>
          <div class="block" v-show="status.img">
            <div class="title">
              <div class="name">
                <i class="iconfont icon-img-add"></i>
                <span style="font-size: 16px;">图片设置</span>
              </div>
              <i @click="status.img = false" class="iconfont icon-close action-icon" style="font-size: 12px;font-weight: 400;color: #657180;"></i>
            </div>
            <div class="content">
              <div class="block-icon-actions" v-loadingx="loading.imgAction">
                <template v-for="menu in imgMenus">
                  <span style="color: rgb(190,190,190);" :key="menu.key + 'span'"  v-if="menu.split">|</span>
                  <fm-poptip :key="menu.key + 'poptip'"  arrow trigger="hover">
                    <div>
                      <i @click="imgAction(menu)" class="img-action-icon" :class="{[menu.icon]: true}"></i>
                      <span v-if="menu.label">{{menu.label}}</span>
                    </div>
                    <div slot="content" style="white-space: nowrap;padding: 5px;">{{menu.desc}}</div>
                  </fm-poptip>
                </template>
              </div>
            </div>
          </div>
          <div class="block tap" @click="addPage">
            <div class="title">
              <div class="name">
                <i class="iconfont icon-add"></i>
                <span style="font-size: 16px;">添加一页</span>
              </div>
            </div>
          </div>
          <div class="block tap" @click="print">
            <div class="title">
              <div class="name">
                <i class="iconfont icon-printer"></i>
                <span style="font-size: 16px;">打印</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fm-modal v-model="status.choose" width="1000px">
      <div class="choose-list">
        <div v-for="(item, i) in sources" :key="i + '-' + item.src" class="choose-img">
          <img @click="chooseImg(item)" :src="item.src" />
        </div>
      </div>
    </fm-modal>
    <div ref="cm2px" style="display: none;padding: 2cm 1.2cm;width: 21.0529166667cm;height: 29.7529166667cm;"></div>
    <iframe style="display: none;" ref="iframe"></iframe>
  </div>
</template>

<script>
import { urlImgRotate2Canvas } from './lib'

export default {
  props: {
    source: { type: Array, default: () => [] }
  },
  data () {
    return {
      sources: [],
      pages: [],
      imgs: [],
      cursor: {
        page: null,
        index: null
      },
      insert: {
        page: null,
        index: null,
        pos: null
      },
      pageSize: {},
      status: {
        choose: false,
        page: false,
        img: false
      },
      loading: {
        imgAction: false
      }
    }
  },
  computed: {
    pageMenus () {
      return [
        { label: false, desc: '添加图片', icon: 'iconfont icon-img-add', key: 'add-img' },
        { label: false, split: true, desc: '水平排列', icon: 'iconfont icon-horizontal', key: 'row-direction' },
        { label: false, desc: '垂直排列', icon: 'iconfont icon-vertical', key: 'column-direction' },
        { label: false, split: true, desc: '在此之前插入一页', icon: 'iconfont icon-before-insert', key: 'before-insert' },
        { label: false, desc: '在此之后插入一张一页', icon: 'iconfont icon-after-insert', key: 'after-insert' },
        { label: false, split: true, desc: '重新自动排版全部图片', icon: 'iconfont icon-layout', key: 'layout' },
        { label: false, split: true, desc: '删除该页', icon: 'iconfont icon-shanchu', key: 'del' }
      ]
    },
    imgMenus () {
      if (this.cursor.page === null) {
        return []
      }

      const direction = this.pages[this.cursor.page].direction
      const menus = [
        { label: false, desc: '向左旋转', icon: 'iconfont icon-left-rotate', key: 'left-rotate' },
        { label: false, desc: '向右旋转', icon: 'iconfont icon-right-rotate', key: 'right-rotate' }
      ]
      
      menus.push(...(direction === 'column' ? [
        { label: false, split: true, desc: '左对齐', icon: 'iconfont icon-left-align', key: 'flex-start-align' },
        { label: false, desc: '水平居中', icon: 'iconfont icon-center-align', key: 'center-align' },
        { label: false, desc: '右对齐', icon: 'iconfont icon-right-align', key: 'flex-end-align' },
        { label: false, split: true, desc: '向上移动', icon: 'iconfont icon-go-top', key: 'left-position' },
        { label: false, desc: '向下移动', icon: 'iconfont icon-go-down', key: 'right-position' }
      ] : [
        { label: false, split: true, desc: '顶对齐', icon: 'iconfont icon-flex-start', key: 'flex-start-justify' },
        { label: false, desc: '垂直居中', icon: 'iconfont icon-center-justify', key: 'center-justify' },
        { label: false, desc: '底对齐', icon: 'iconfont icon-flex-end', key: 'flex-end-justify' },
        { label: false, split: true, desc: '向左移动', icon: 'iconfont icon-go-left', key: 'left-position' },
        { label: false, desc: '向右移动', icon: 'iconfont icon-go-right', key: 'right-position' }
      ]))
        
      menus.push(
        { label: false, split: true, desc: '在此之前插入一张图片', icon: 'iconfont icon-before-insert', key: 'before-insert' },
        { label: false, desc: '在此之后插入一张图片', icon: 'iconfont icon-after-insert', key: 'after-insert' },
        { label: false, split: true, desc: '删除', icon: 'iconfont icon-shanchu', key: 'del' }
      )

      return menus
    }
  },
  watch: {
    async source () {
      this.loadImgData()
    }
  },
  methods: {
    print () {
      let html = this.$refs.content.innerHTML
      // eslint-disable-next-line no-useless-escape
      let tpl = '<!DOCTYPE html><head><link rel="stylesheet" href="/static/document/img-print.css"></head><body class="img-doc-print">' + html + "</body><script>document.addEventListener('DOMContentLoaded', function () {setTimeout(function () {window.print();}, 0);});<\/script></html>"
      this.$refs.iframe.srcdoc = tpl
    },
    delPage () {
      this.pages.splice(this.cursor.page, 1)
      this.imgs = this.pages.map(v => v.imgs).flat()
      this.cursor.page = null
      this.cursor.index = null
      this.status.page = false
      this.status.img = false
    },
    async pageAction (menu) {
      let page = this.pages[this.cursor.page]
      switch (menu.key) {
        case 'add-img':
          this.addImg(this.cursor.page)
          break
        case 'row-direction':
        case 'column-direction':
          page.direction = menu.key.replace('-direction', '')
          this.pages.splice(this.cursor.page, 1, page)
          break
        case 'before-insert':
          if (this.cursor.page < 1) {
            this.pages.unshift({
              direction: 'column',
              imgs: []
            })
          } else {
            this.pages.splice(this.cursor.page, 1, {
              direction: 'column',
              imgs: []
            }, this.pages[this.cursor.page])
          }
          this.cursor.page = this.cursor.page + 1
          break
        case 'after-insert':
          if (this.cursor.page >= this.pages.length - 1) {
            this.pages.push({
              direction: 'column',
              imgs: []
            })
          } else {
            this.pages.splice(this.cursor.page, 1, this.pages[this.cursor.page], {
              direction: 'column',
              imgs: []
            })
          }
          break
        case 'layout':
          this.autoLayout()
          break
        case 'del':
          this.delPage()
          break
      }
    },
    async imgAction (menu) {
      this.loading.imgAction = true
      let page = this.pages[this.cursor.page], canvas = null
      let { original_src, src } = page.imgs[this.cursor.index]

      switch (menu.key) {
        case 'left-rotate':
        case 'right-rotate':
          page.imgs[this.cursor.index].rotate = (page.imgs[this.cursor.index].rotate + ({
            'left-rotate': -90,
            'right-rotate': 90
          })[menu.key]) % 360
          if (page.imgs[this.cursor.index].rotate === 0) {
            page.imgs[this.cursor.index].src = original_src
          } else {
            canvas = await urlImgRotate2Canvas(original_src, page.imgs[this.cursor.index].rotate)
            page.imgs[this.cursor.index].src = await new Promise(resolve => {
              canvas.toBlob((blob) => {
                resolve(URL.createObjectURL(blob))
              }, 'image/png')
            })
          }
          if (src !== original_src && src.indexOf('blob://') === 0) {
            URL.revokeObjectURL(src)
          }
          this.pages.splice(this.cursor.page, 1, page)
          break
        case 'flex-start-justify':
        case 'center-justify':
        case 'flex-end-justify':
          page.imgs[this.cursor.index].align = menu.key.replace('-justify', '')
          this.pages.splice(this.cursor.page, 1, page)
          break
        case 'flex-start-align':
        case 'center-align':
        case 'flex-end-align':
          page.imgs[this.cursor.index].align = menu.key.replace('-align', '')
          this.pages.splice(this.cursor.page, 1, page)
          break
        case 'before-insert':
          this.addImg(this.cursor.page, this.cursor.index, 'before-insert')
          break
        case 'after-insert':
          this.addImg(this.cursor.page, this.cursor.index, 'after-insert')
          break
        case 'left-position':
          if (this.cursor.index === 0) {
            if (this.cursor.page > 0) {
              this.cursor.page = this.cursor.page - 1
              this.pages[this.cursor.page].imgs.push(page.imgs[this.cursor.index])
              page.imgs.splice(this.cursor.index, 1)
              this.pages.splice(this.cursor.page, 2, this.pages[this.cursor.page], page)
              this.cursor.index = this.pages[this.cursor.page].imgs.length - 1
            }
          } else {
            page.imgs.splice(this.cursor.index - 1, 2, page.imgs[this.cursor.index], page.imgs[this.cursor.index - 1])
            this.pages.splice(this.cursor.page, 1, page)
            this.cursor.index -= 1
          }
          this.focusInCursor();
          break
        case 'right-position':
          if (this.cursor.index >= page.imgs.length - 1) {
            if (this.cursor.page < this.pages.length - 1) {
              this.pages[this.cursor.page + 1].imgs.unshift(page.imgs[this.cursor.index])
              page.imgs.splice(this.cursor.index, 1)
              this.pages.splice(this.cursor.page, 2, page, this.pages[this.cursor.page + 1])
              this.cursor.page += 1
              this.cursor.index = 0
            }
          } else {
            page.imgs.splice(this.cursor.index, 2, page.imgs[this.cursor.index + 1], page.imgs[this.cursor.index])
            this.cursor.index += 1
            this.pages.splice(this.cursor.page, 1, page)
          }
          this.focusInCursor();
          break
        case 'del':
          page.imgs.splice(this.cursor.index, 1)
          this.pages.splice(this.cursor.page, 1, page)
          break
      }
      this.imgs = this.pages.map(v => v.imgs).flat()
      this.loading.imgAction = false
    },
    focusInCursor () {
      this.$nextTick(() => {
        let el = null
        if (!(!this.cursor.index && this.cursor.index !== 0)) {
          el = this.$refs.content.querySelector('[data-page-img-index="' + this.cursor.page + '-' + this.cursor.index + '"]')
        } else {
          el = this.$refs.content.querySelector('[data-page-index="'+ this.cursor.page + '"]')
        }

        el && el.scrollIntoView()
      })
    },
    togglePage (i) {
      if (this.cursor.page !== i || (this.cursor.page === i && !this.status.page)) {
        this.status.page = true
        this.cursor.page = i
      } else {
        this.status.page = false
      }
      this.status.img = false
      this.cursor.index = null
    },
    toggleImg (i, l) {
      if ((this.cursor.page !== i || this.cursor.index !== l) || ((this.cursor.page === i || this.cursor.index === l) && !this.status.img)) {
        this.status.img = true
        this.cursor.page = i
        this.cursor.index = l
      } else {
        this.status.img = false
      }
    },
    chooseImg (item) {
      if (this.insert.page !== null && this.pages[this.insert.page]) {
        const img = JSON.parse(JSON.stringify(item))
        const page = this.pages[this.insert.page]

        if (this.insert.pos === 'append') {
          page.imgs.push(img)
        } else if (this.insert.pos === 'before-insert' && page.imgs[this.insert.index]) {
          if (this.insert.index > 0) {
            page.imgs.splice(this.insert.index, 1, img, page.imgs[this.insert.index])
          } else {
            page.imgs.unshift(img)
          }
          this.insert.index = this.insert.index + 1
          this.cursor.index = this.cursor.index + 1
        } else if (this.insert.pos === 'after-insert' && page.imgs[this.insert.index]) {
          if (this.insert.index < page.imgs.length - 1) {
            page.imgs.splice(this.insert.index, 1, page.imgs[this.insert.index], img)
          } else {
            page.imgs.push(img)
          }
        }

        this.pages.splice(this.insert.page, 1, page)
        this.imgs = this.pages.map(v => v.imgs).flat()
      }
      this.status.choose = false
    },
    addImg (page, index = false, pos = 'append') {
      this.insert.page = page
      this.insert.index = index
      this.insert.pos = pos
      this.status.choose = true
    },
    addPage () {
      this.pages.push({
        direction: 'column',
        imgs: []
      })
    },
    autoLayout () {
      let pages = []
      this.imgs.forEach(item => {
        let page = !pages.length ? {
          direction: 'column',
          imgs: []
        } : pages[pages.length - 1]

        if (!pages.length) {
          pages.push(page)
        }

        const used = page.imgs.reduce((a, b) => a + b.height, 0)
        console.log('use and height', '使用', used, '剩余', this.pageSize.contentHeight - used, '图高', item.height, item)
        if (item.height > (this.pageSize.contentHeight - used)) {
          page = {
            direction: 'column',
            imgs: [
              item
            ]
          }
          pages.push(page)
        } else {
          page.imgs.push(item)
        }
      })
      this.pages = pages
    },
    async loadImgData () {
      let promise = this.source.map(src => {
        return new Promise(resolve => {
          let img = new Image()
          img.src = src
          img.onload = () => {
            let width = img.width
            let height = img.height

            const ratio = width / height
            if (ratio > 1) {
              height = this.pageSize.contentWidth / ratio
              width = this.pageSize.contentWidth
            } else {
              height = this.pageSize.contentHeight
              width = this.pageSize.contentHeight * ratio
            }

            resolve({
              src: src,
              original_src: src,
              width: width,
              height: height,
              rotate: 0,
              align: 'center',
              justify: 'center',
              original_width: img.width,
              original_height: img.height,
            })
          }
        })
      })
      this.sources = await Promise.all(promise)
      this.imgs = JSON.parse(JSON.stringify(this.sources))
      this.autoLayout()
    },
    quit () {
      this.$emit('quit')
    }
  },
  mounted () {
    const styles = getComputedStyle(this.$refs.cm2px)
    const pageSize = {
      width: Number(styles.width.replace('px', '')),
      height: Number(styles.height.replace('px', '')),
      paddingTop: Number(styles.paddingTop.replace('px', '')),
      paddingLeft: Number(styles.paddingLeft.replace('px', '')),
      paddingRight: Number(styles.paddingRight.replace('px', '')),
      paddingBottom: Number(styles.paddingBottom.replace('px', ''))
    }

    pageSize.contentWidth = pageSize.width - pageSize.paddingLeft - pageSize.paddingRight
    pageSize.contentHeight = pageSize.height - pageSize.paddingTop - pageSize.paddingBottom

    console.log(pageSize)

    this.pageSize = pageSize
    this.loadImgData()
  }
}
</script>
